import React, { useCallback, useState } from 'react';
import { observer } from 'mobx-react';
import Notification from '@this/src/notification';
import { Button } from '@this/src/components/shared/ui/inputs/button';
import { TableCell, TableRow } from '@this/src/components/shared/ui/data_displays/table';
import type BizEkinetReservation from '@this/src/domain/arrangement/biz_ekinet_reservation_total';
import type { ArrangerArgs } from '@this/src/domain/arranger/arranger';
import { Fetcher } from '@this/src/util';

interface Props {
  bizEkinetReservationTotal: BizEkinetReservation;
  onApprove: () => void;
}

interface ApproveResponse {
  biz_ekinet_auto_reservation_total_approval: {
    reservation_date: string;
    approved_at: string;
    approved_by: ArrangerArgs;
  };
}

const AirAutoBizEkinetReservationTotalTableRow: React.FC<Props> = observer(
  ({ bizEkinetReservationTotal, onApprove }) => {
    const [loading, setLoading] = useState(false);

    const handleApprove = useCallback(() => {
      setLoading(true);
      const params = {
        reservation_date: bizEkinetReservationTotal.reservationDate.format('YYYY-MM-DD')
      };
      Fetcher.post<ApproveResponse>(
        '/arrangement/auto_reservation_inventory/biz_ekinet_booking/total/confirm.json',
        params
      )
        .then(res => {
          Notification.success(
            `${res.biz_ekinet_auto_reservation_total_approval.reservation_date}の承認が完了しました`
          );
        })
        .finally(() => {
          setLoading(false);
          onApprove();
        });
    }, [bizEkinetReservationTotal, setLoading]);

    return (
      <TableRow>
        <TableCell>{bizEkinetReservationTotal.reservationDate.format('YYYY-MM-DD')}</TableCell>
        <TableCell>{bizEkinetReservationTotal.aiOperatorCount?.toLocaleString() || 0}</TableCell>
        <TableCell>{bizEkinetReservationTotal.reservationCount?.toLocaleString() || 0}</TableCell>
        <TableCell>{bizEkinetReservationTotal.totalPrice?.toLocaleString() || 0}</TableCell>
        <TableCell>{bizEkinetReservationTotal.approvedAt?.format('YYYY-MM-DD') || '─'}</TableCell>
        <TableCell>{bizEkinetReservationTotal.approvedBy || '─'}</TableCell>
        <TableCell>
          {bizEkinetReservationTotal.approvedBy ? (
            <div style={{ padding: '8px 0' }}>確認済み</div>
          ) : (
            <Button onClick={handleApprove} loading={loading}>
              確認
            </Button>
          )}
        </TableCell>
      </TableRow>
    );
  }
);

export default AirAutoBizEkinetReservationTotalTableRow;
